import { render, staticRenderFns } from "./CapacitacionesExternas.vue?vue&type=template&id=04afecb6&scoped=true"
import script from "./CapacitacionesExternas.vue?vue&type=script&lang=js"
export * from "./CapacitacionesExternas.vue?vue&type=script&lang=js"
import style0 from "./CapacitacionesExternas.vue?vue&type=style&index=0&id=04afecb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04afecb6",
  null
  
)

export default component.exports